import React from 'react';
import { useState } from 'react';
import uuid from 'uuid';
import { ErrorBoundary } from 'react-error-boundary';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { CardWithUrlContent } from './view/CardWithUrl/component';
import { LoadingCardLink } from './view/CardWithUrl/component-lazy/LoadingCardLink';
import { context } from './utils/analytics/analytics';
// SSR friendly version of smart-card
// simplifies the logic around rendering and loading placeholders and
// only contains whats necessary to render the card on SSR mode
export const CardSSR = props => {
  const [id] = useState(() => {
    var _props$id;
    return (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : uuid();
  });
  const cardProps = {
    ...props,
    id
  };
  return /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: context
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    FallbackComponent: () => /*#__PURE__*/React.createElement(LoadingCardLink, cardProps)
  }, /*#__PURE__*/React.createElement(CardWithUrlContent, cardProps)));
};